export default __webpack_public_path__ + "static/Confetti-Desktop-630979539c7ee5568deacf757f3128ac.svg";